import { useAuth } from "../../context/AuthContext";
import { PoliciesSection } from "../../components/admin/settings/PoliciesSection";
import { DepartmentsSection } from "../../components/admin/settings/DepartmentsSection";
import { ShiftsSection } from "../../components/admin/settings/ShiftsSection";
import { DangerZone } from "../../components/admin/settings/DangerZone";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="space-y-8 max-w-4xl" data-testid="settings-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Settings</h1>
        <p className="text-stone-500 text-sm mt-1">Leave policies, organization structure and shifts.</p>
      </div>
      <PoliciesSection />
      <DepartmentsSection />
      <ShiftsSection />
      {user?.role === "super_admin" && <DangerZone />}
    </div>
  );
}
